<template>
	<div id="couponform">
		<ul>
			<li>
				<p class="title">提交信息，领取{{coupon_price}}元《提分宝典》优惠券</p>
			</li>
			<li>
				<!-- <p class="form_con">联系人 <span style="color: #ff0000;">*</span></p> -->
				<input type="text" name="consignee" v-model="consignee" placeholder="姓名">
				<img src="@assets/images/icon_03.png"/>
			</li>
			<li>
				<!-- <p class="form_con">联系电话 <span style="color: #ff0000;">*</span></p> -->
				<input type="number" pattern="[0-9]*" name="phone" v-model="phone" placeholder="手机"/>
				<img src="@assets/images/icon_06.png"/>
			</li>
			<!-- <li>
				<p class="form_con">学校名称 <span style="color: #ff0000;">*</span></p>
				<input type="text" name="school_name" v-model="school_name" placeholder="学校">
				<img src="@assets/images/icon_08.png"/>
			</li> -->
			<!-- <li style="position: relative;">
				<span v-if="!school_name" class="placehoder">学校</span>
				<select class="schoolselect" v-model="school_name">
					<option v-for="(school,key) in shoollist" :key="key" :value="school.value">{{school.value}}</option>
				</select>
				<img src="@assets/images/icon_08.png"/>
			</li> -->
			<li style="position: relative;">
				<img src="@assets/images/icon_08.png"/>
				<div id="test">
				  <select class="schoolselect" v-model="selected">
				    <option v-for="yx in shoollist" :value="yx.text">
				        {{yx.text}}
				    </option>
				  </select>
				  <select class="schoolselect select-r" v-model="class_name">
				    <option v-for="classa in selection" :value="classa.text" :selected="$index == 0 ? true : false">
				        {{classa.text}}
				    </option>
				  </select>
				</div>
			</li>
			<li>
				<div @click="submit()" class="submit">提交</div>
			</li>
		</ul>
		<div class="bottom"><img src="@assets/images/form_bg.png" alt=""></div>
	</div>
</template>
<script>
import { getCouponForm, CouponForm } from "@api/user";
export default {
	name: "CouponForm",
	components: {},
	props: {},
	data: function() {
		return {
			coupon_price:"",
			consignee:"",
			phone:"",
			school_name:"",
			class_name:"",
			// shoollist:[],
			selected: '请选择',
			shoollist: []
		}
	},
	created() {},
	watch: {
		$route(n){
			if(n){
				// this.getCouponForm();
			}
		}
	},
	computed: {
	    selection: {
	      get: function() {
	        var that = this;
			if(that.selected == undefined) return;
			if(!this.shoollist.length) return ;
			console.log(that.selected);
	        return this.shoollist.filter(function(item) {
	          return item.text == that.selected;
	        })[0].classlist;
	      }
	    }
	  },
	mounted: function() {
		this.getCouponForm();
		this.getSchool();
	},
	methods: {
		getSchool(){
			let that = this;
			this.axios.get("https://oa.fc62.com/api/ajax/base_school_class").then((res) => {
				that.shoollist = res.data.data;
				console.log(that.shoollist)
			}).catch((err) => {
				that.$dialog.error(res.data.msg);
			});
		},
		getCouponForm(){
			let that = this;
			getCouponForm(that.$route.params.id).then(res => {
				that.coupon_price = res.data.CouponInfo.coupon_price;
				if(res.data.jump_status == 1 && res.data.info){
					that.consignee = res.data.info.name;
					that.phone = res.data.info.phone;
					that.selected = res.data.info.school_name == undefined ? '请选择' : res.data.info.school_name;
					console.log(that.selected)
					that.class_name = res.data.info.school_class;
				}
				if(res.data.jump_status == 2){
					window.location.href = res.data.jump_url;
				}
				if(res.data.jump_status == 3){
					that.$dialog.error(res.data.msg);
				}
			}).catch(err => {
				that.$dialog.error(err.msg);
				setTimeout(function(){
					that.$router.push("/");
				},1000);
			});
		},
		submit(){
			let that = this;
			console.log(that.selected)
			console.log(that.class_name)
			if(that.consignee == "" || that.consignee == undefined){
				that.$dialog.error("请填写联系人");
				return false;
			}
			if(!(/^1[3456789]\d{9}$/.test(that.phone))) {
				that.$dialog.error("请填写正确的手机号码");
				return false;
			}
			if(that.selected == "请选择" || that.selected == undefined){
				that.$dialog.error("请选择学校");
				return false;
			}
			
			// if(that.class_name == "请选择" || that.class_name == undefined){
			// 	that.$dialog.error("请选择班级");
			// 	return false;
			// }
			let urlSource = that.$cookies.get('urlSource');
			CouponForm({
				name: that.consignee,
				phone: that.phone,
				school_name: that.selected,
				school_class: that.class_name,
				id:that.$route.params.id,
				source:urlSource
			}).then(res => {
				if(res.data.jump_status == 2){
					window.location.href = res.data.jump_url;
				}
				if(res.data.jump_status == 3){
					that.$dialog.error(res.data.msg);
				}
				console.log("成功")
			}).catch(err => {
				that.$dialog.error(err.msg);
			});
		}
	}
};
</script>
<style scoped>
#couponform{
	padding: 0.5rem;
}
#couponform ul{
	background-color: #fff;
	padding: 0.6rem 0.5rem 0.5rem 0.5rem;
	border-radius: 8px;
	box-shadow: 0 0 10px #ddd;
}
#couponform li{
	position: relative;
	margin-bottom: 0.47rem;
}

#couponform li:last-child{
	margin-bottom: 0;
}
.title{
	text-align: center;
	font-size: 0.32rem;
	color: #333;
}
.form_con{
	color: #333;
	font-size: 0.3rem;
}
input{
	border: 1px solid #bbbbbb;
	border-radius: 5px;
	width: 100%;
	height: 0.7rem;
	line-height: 0.7rem;
	margin-top: 0.15rem;
	text-indent: 0.6rem;
}
.schoolselect{
	border: 1px solid #bbb;
	width: 48%;
	height: 0.7rem;
	/* line-height: 0.7rem; */
	text-indent: 0.6rem;
	appearance: none;
	-webkit-appearance: none;
	color: #333;
	background: url("http://tmall.fc62.com/mobile/themesmobile/68ecshopcom_mobile/images/selectjt.jpg") no-repeat scroll right center transparent;
	background-size: 0.4rem;
	padding-right: 17px; 
	border-radius: 5px;
}
.schoolselect-nocheck{
	border: 1px solid #bbb;
	width: 48%;
	height: 0.7rem;
	/* line-height: 0.7rem; */
	text-indent: 0.6rem;
	appearance: none;
	-webkit-appearance: none;
	color: #777;
	background: url("http://tmall.fc62.com/mobile/themesmobile/68ecshopcom_mobile/images/selectjt.jpg") no-repeat scroll right center transparent;
	background-size: 0.4rem;
	padding-right: 17px; 
	border-radius: 5px;
}
.select-r{
	margin-left: 4%;
}
.placehoder{
	position: absolute;
	color: #777;
	top: 0.15rem;
	left: 0.65rem;
}
.placehoder-class{
	position: absolute;
	color: #777;
	top: 0.15rem;
	left: 65%;
}
#couponform li img{
	position: absolute;
	bottom: 0.17rem;
	left: 0.2rem;
	width: 0.3rem;
}
.submit{
	width: 100%;
	height: 0.73rem;
	line-height: 0.73rem;
	text-align: center;
	color: #fff;
	background-color: #ff2210;
	border-radius: 5px;
	font-size: 0.32rem;
}
.bottom{
	position: fixed;
	bottom: 0;
}
.bottom img{
	display: block;
	width: 90%;
}
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-device-pixel-ratio: 2) {
    .bottom img{
    	display: block;
    	width: 70%;
		margin: 0 auto;
    }
 }
@media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-device-pixel-ratio: 3) {
    .bottom img{
    	display: block;
    	width: 80%;
		margin: 0 auto;
    }
}
</style>
